import { ARCHIVE_TARGET, ARCHIVE_PAGINATION } from '../constants'

function handleErrors (error) {
    console.log(error)
}

function updateMarkup (response, archive) {
    const target = archive.querySelector(`[${ARCHIVE_TARGET}]`)
    const pagination = archive.querySelector(`[${ARCHIVE_PAGINATION}]`)

    if (target) {
        target.innerHTML = response.markup
    }

    if (pagination) {
        pagination.innerHTML = response.pagination
    }
}

export { handleErrors, updateMarkup }